const getEnvironmentVariable = (key: string): string | undefined => {
  const value = process.env[key];
  return value;
};
const getRequiredEnvironmentVariable = (key: string): string => {
  const value = getEnvironmentVariable(key);
  if (value === undefined) {
    throw new Error(`Environment variable ${key} is not defined`);
  }
  return value;
};

export const appConfig = {
  apiBaseUrl: getRequiredEnvironmentVariable("REACT_APP_API_BASE_URL"),
  lvAceBaseUrl: getRequiredEnvironmentVariable("REACT_APP_LVACE_BASE_URL"),
  geoserverBaseUrl: getRequiredEnvironmentVariable("REACT_APP_GEOSERVER_BASE_URL"),
  calculate: getRequiredEnvironmentVariable("REACT_APP_CALCULATE"),
  calculateNoAssessment: getRequiredEnvironmentVariable("REACT_APP_CALCULATE_NO_ASSESSMENT"),
  shortestPath: getRequiredEnvironmentVariable("REACT_APP_SHORTEST_PATH"),
  layerUrl: getRequiredEnvironmentVariable("REACT_APP_LAYER_URL"),
  groundTypesUrl: getRequiredEnvironmentVariable("REACT_APP_GROUNDTYPES_URL"),
  osApiKey: getRequiredEnvironmentVariable("REACT_APP_OS_API_KEY"),
  publicRagConnectivity: getRequiredEnvironmentVariable("REACT_APP_PUBLIC_RAG_CONNECTIVITY"),
  icpRagConnectivity: getRequiredEnvironmentVariable("REACT_APP_ICP_RAG_CONNECTIVITY"),
  ngedRagConnectivity: getRequiredEnvironmentVariable("REACT_APP_NGED_RAG_CONNECTIVITY"),
  developerRagConnectivity: getRequiredEnvironmentVariable("REACT_APP_DEVELOPER_RAG_CONNECTIVITY"),
  redColor: getRequiredEnvironmentVariable("REACT_APP_RED_COLOR"),
  amberColor: getRequiredEnvironmentVariable("REACT_APP_AMBER_COLOR"),
  greenColor: getRequiredEnvironmentVariable("REACT_APP_GREEN_COLOR"),
  unknownColor: getRequiredEnvironmentVariable("REACT_APP_UNKNOWN_COLOR"),
  cableTypeIdBlacklist: JSON.parse(
    getRequiredEnvironmentVariable("REACT_APP_CABLE_TYPE_ID_BLACKLIST")
  ),
  featureFullScreen: getRequiredEnvironmentVariable("REACT_APP_FEATURE_FULL_SCREEN"),
  featureUserGuidance: getRequiredEnvironmentVariable("REACT_APP_FEATURE_USER_GUIDANCE"),
  featureDebugger: getRequiredEnvironmentVariable("REACT_APP_FEATURE_DEBUGGER"),
  featureSelectFeature: getRequiredEnvironmentVariable("REACT_APP_FEATURE_SELECT_FEATURE"),
  featureEditMainsCable: getRequiredEnvironmentVariable("REACT_APP_FEATURE_EDIT_MAINS_CABLE"),
  featureEditPlan: getRequiredEnvironmentVariable("REACT_APP_FEATURE_EDIT_PLAN"),
  featureQuotationPlan: getRequiredEnvironmentVariable("REACT_APP_FEATURE_QUOTATION_PLAN"),
  featureLayers: getRequiredEnvironmentVariable("REACT_APP_FEATURE_LAYERS"),
  featureAddImage: getRequiredEnvironmentVariable("REACT_APP_FEATURE_SCHEMATIC"),
  featureSave: getRequiredEnvironmentVariable("REACT_APP_FEATURE_SAVE"),
  quotationText1: getRequiredEnvironmentVariable("REACT_APP_CONFIG_QUOTATION_PLAN_TEXT1"),
  quotationText2: getRequiredEnvironmentVariable("REACT_APP_CONFIG_QUOTATION_PLAN_TEXT2"),
  quotationText3: getRequiredEnvironmentVariable("REACT_APP_CONFIG_QUOTATION_PLAN_TEXT3"),
  quotationLogo: getRequiredEnvironmentVariable("REACT_APP_CONFIG_QUOTATION_PLAN_LOGO"),
  startLocation: JSON.parse(getRequiredEnvironmentVariable("REACT_APP_CONFIG_START_LOCATION")),
  visibleLayers: JSON.parse(getRequiredEnvironmentVariable("REACT_APP_CONFIG_LAYERS_VISIBLE")),
  appInsightsConnnectionString: getEnvironmentVariable("REACT_APP_APPINSIGHTS_CONNECTION_STRING"),
};
